import {useDebugValue} from 'react';

import {useEdapProvider} from './useEdapProvider';
import {useSearchFormContextProvider} from './useSearchFormContextProvider';

function useComponent(props) {
    const {
        value: searchFormContext
    } = useSearchFormContextProvider(props);

    const {
        fields: edapFields,
        options: edapOptions,
        eventFields: edapEventFields,
        eventOptions: edapEventOptions
    } = useEdapProvider(searchFormContext);

    const result = {
        edapProviderFields: edapFields,
        edapProviderOptions: edapOptions,
        edapProviderEventFields: edapEventFields,
        edapProviderEventOptions: edapEventOptions,
        searchFormContextProviderValue: searchFormContext
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
